import axios from "axios";
import util from '@/util';

export default axios.create({ baseURL: util.getApiUrl() });
